import { useRoutes } from 'react-router-dom';
import routes from './routes/router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ThemeProvider from './theme/ThemeProvider';
import { CssBaseline } from '@mui/material';
const App = () => {

  // const content = useRoutes(routes);
  var userDatas = JSON.parse(localStorage.getItem('userDatas'));
  const tokenValue = localStorage.getItem('userDatas') ? userDatas.token  : '';
  const routing = useRoutes(routes(tokenValue));
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {routing}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
